import type { ReactNode } from "react";

/**
 * The two-panel row.
 *
 * `items-start` lets each panel end where its rows do rather than padding the
 * shorter one out to match its neighbour. Two columns only above `xl` — below
 * that the numeric columns of two tables side by side are narrower than the
 * numbers in them.
 *
 * A third panel does not go here. Two tables read against each other; three
 * are a list, and a list belongs in the detail region.
 */
export function AdminBreakdownGrid({ children }: { children: ReactNode }) {
  return <div className="grid shrink-0 items-start gap-4 xl:grid-cols-2">{children}</div>;
}
